/* eslint-disable no-console */

export const DebugLevels = {
  DEBUG: 0,
  INFO: 1,
  WARN: 2,
  ERROR: 3
};

let currentDebugLevel = DebugLevels.DEBUG;

/**
 * LogClient implementation that allows logging to multiple places by delegating to other clients.
 * A practical use case is logging to both console and server in development regions.
 **/
export class CompositeLogClient {
  constructor(...clients) {
    this.clients = clients;
  }
  debug = (...args) => {
    this.clients.forEach(client => client.debug(...args));
  };

  info = (...args) => {
    this.clients.forEach(client => client.info(...args));
  };

  warn = (...args) => {
    this.clients.forEach(client => client.warn(...args));
  };

  error = (...args) => {
    this.clients.forEach(client => client.error(...args));
  };
}

/** Simple Log Client that writes to console **/
export class ConsoleLogClient {
  debug = (...args) => {
    const [marker, ...rest] = args;
    if (typeof window === 'undefined') {
      console.log(`[${marker}]: `, ...rest);
    } else {
      window.console.log(`[${marker}]: `, ...rest);
    }
  };

  info = (...args) => {
    const [marker, ...rest] = args;
    if (typeof window === 'undefined') {
      console.info(`[${marker}]: `, ...rest);
    } else {
      window.console.info(`[${marker}]: `, ...rest);
    }
  };

  warn = (...args) => {
    const [marker, ...rest] = args;
    if (typeof window === 'undefined') {
      console.warn(`[${marker}]: `, ...rest);
    } else {
      window.console.warn(`[${marker}]: `, ...rest);
    }
  };

  error = (...args) => {
    const [marker, ...rest] = args;
    if (typeof window === 'undefined') {
      console.error(`[${marker}]: `, ...rest);
    } else {
      window.console.error(`[${marker}]: `, ...rest);
    }
  };
}

let currentLogClient = new ConsoleLogClient();

/**
 * Logger class used to add application logging to modules..
 * Typically create a new instance per module / source file as follows
 * const LOG = new Logger('MyModuleName');
 * Then use in the module using LOG.debug/warn/error
 **/
export default class Logger {
  // TODO: allow setting debug level configuration per known 'prefix'
  // TODO: match log format we use in splunk? (or should backend do this?)

  constructor(marker) {
    this.marker = marker;
  }

  debug(...args) {
    if (currentDebugLevel <= DebugLevels.DEBUG) {
      currentLogClient.debug(this.marker, ...args);
    }
  }

  info(...args) {
    if (currentDebugLevel <= DebugLevels.INFO) {
      currentLogClient.info(this.marker, ...args);
    }
  }

  warn(...args) {
    if (currentDebugLevel <= DebugLevels.WARN) {
      currentLogClient.warn(this.marker, ...args);
    }
  }

  error(...args) {
    if (currentDebugLevel <= DebugLevels.ERROR) {
      currentLogClient.error(this.marker, ...args);
    }
  }
}

/* Set Global Debug Level for all logger instances */
export function setDebugLevel(debugLevel) {
  currentDebugLevel = debugLevel;
}

/* Set Global LogClient for all logger instances */
export function setLogClient(logClient) {
  currentLogClient = logClient;
}
